<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md12>
        <material-card color="green" :title="quiz_title + ' || ' + quizDetail.exam_name">
          <v-layout wrap>
            <v-flex xs10 md10>
              <v-layout wrap>
                <v-flex xs12 md6><b>Duration: </b> {{ quizDetail.duration }} mins </v-flex>
                <v-flex xs12 md6><b>Total Questions: </b> {{ quizDetail.questions_count }}  </v-flex>
                <v-flex xs12 md6> <b>Minimum Questions: </b> {{ quizDetail.question_number }}  </v-flex>
                <v-flex xs12 md6><b>Mark: </b> {{ quizDetail.total_mark }}  </v-flex>
                <v-flex xs12 md6><b>Positive mark: </b> {{ quizDetail.positive_mark }}  </v-flex>
                <v-flex xs12 md6><b>Negative mark: </b> {{ quizDetail.negative_mark }}   </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs2 md2>

            <!-- <a href="#" @click.prevent="enabaleExamEdit(quizDetail)">Edit</a> -->
            <v-btn 
              color="green"
              @click="enabaleExamEdit(quizDetail)"
            >Edit</v-btn>
            <v-btn right
              color="green"
              v-if="quizDetail.status == 'unpublished' && quizDetail.questions_count >= quizDetail.question_number"
              @click="updateExam(quizDetail, 'published')"
            >Publish</v-btn>
            <v-btn 
                right
                class="mt-3"
              color="warning"
              v-else-if="quizDetail.status == 'published' && quizDetail.questions_count >= quizDetail.question_number"
              @click="updateExam(quizDetail, 'unpublished')"
            >Unpublish</v-btn>
            <v-btn color="red" v-else>Unpublished</v-btn>
            </v-flex>
          </v-layout>

            <v-btn @click="getExamId(quizDetail)" color="success" dark>Add question</v-btn>
            <v-dialog v-model="dialogQuestion" width="1000" persistent>
              <template v-slot:activator="{ on }">
              </template>
              <v-card>
                <FormExamQuestion :Data="examObj" @emitted="submitQuestion"
                 @closedQuestion="closeQuestionModal"
                 :QuestionNumber="examObj.questions_count"
                 />
              </v-card>
            </v-dialog>
            
          <v-dialog v-if="dialogEdit" v-model="dialogEdit" width="1000" persistent>
            <template v-slot:activator="{ on }"></template>
            <v-card>
              <Form :Item="item"
                :Field="inputFields"
                :Value="editItem"
                @emitted="updateExamFields"
                @closed="closeModal" />
            </v-card>
          </v-dialog>
            <v-divider></v-divider>
            
          <v-layout wrap v-for="(item, index) in questionList" :key="index">
            <v-flex xs12 md12 class="bold-font">{{ index + 1 }}. {{ item.question }} 
              
              <b v-if="item.explanation"><a href="#" @click.prevent="viewExplanation(item.explanation)" class="blue--text"> Explanation</a> </b>

              <a href="#" class="float-right blue--text" @click.prevent="editQuestion(item)">Edit</a> </v-flex>
            <v-flex :class="{'green--text' : item.correct_answer == 1}" xs12 md6><b>(a) {{ item.option1 }} </b>  </v-flex>

            <template v-if="item.correct_answer > 1"> 

            <v-flex :class="{'green--text' : item.correct_answer == 2}" xs12 md6><b>(b) {{ item.option2 }} </b>  </v-flex>
            <v-flex :class="{'green--text' : item.correct_answer == 3}" xs12 md6><b>(c) {{ item.option3 }} </b>  </v-flex>
            <v-flex :class="{'green--text' : item.correct_answer == 4}" xs12 md6><b>(d) {{ item.option4 }} </b>  </v-flex>
            <v-flex  v-if="item.option5 != null" :class="{'green--text' : item.correct_answer == 5}" xs12 md6><b>(e) {{ item.option5 }} </b>  </v-flex>
            <v-flex  v-if="item.option6 != null"  :class="{'green--text' : item.correct_answer == 6}" xs12 md6><b>(f) {{ item.option6 }} </b>  </v-flex>
            </template>
            <template v-else>
             
            <v-flex :class="{'green--text' : item.correct_answer2 == 2}" xs12 md6><b>(b) {{ item.option2 }} </b>  </v-flex>
            <v-flex :class="{'green--text' : item.correct_answer3 == 3}" xs12 md6><b>(c) {{ item.option3 }} </b>  </v-flex>
            <v-flex :class="{'green--text' : item.correct_answer4 == 4}" xs12 md6><b>(d) {{ item.option4 }} </b>  </v-flex>
            <v-flex v-if="item.option5 != null" :class="{'green--text' : item.correct_answer5 == 5}" xs12 md6><b>(e) {{ item.option5 }} </b>  </v-flex>
            <v-flex v-if="item.option6 != null" :class="{'green--text' : item.correct_answer6 == 6}" xs12 md6><b>(f) {{ item.option6 }} </b>  </v-flex>

            </template>



            
        
            
           
          </v-layout>
              
            <v-dialog v-model="dialogExplanation" width="1200">
              <template v-slot:activator="{ on }">
              </template>
              <v-card>
                <img :src="'http://api.bacbonschool.com/uploads/question_explanation/' + explanationImage" alt="" style="width: 100%; height: auto">
              </v-card>
            </v-dialog>
              
              
           <v-dialog v-model="dialogQuestionEdit" width="1000" persistent>
              <template v-slot:activator="{ on }">
              </template>
              <v-card>
                <FormExamQuestionEdit :Data="quizDetail" @emitted="updateQuestion"
                 @closedQuestion="closeQuestionEditModal"
                 :Question="questionEdit"
                 />
              </v-card>
            </v-dialog>

        </material-card>
      </v-flex>
      <v-snackbar
      :color="color"
      :bottom="bottom"
      :top="top"
      :left="left"
      :right="right"
      v-model="snackbar"
      dark
    >
      <v-icon color="white" class="mr-3">mdi-bell-plus</v-icon>
      <div>{{ noticeMessage }}</div>
      <v-icon size="16" @click="snackbar = false">mdi-close-circle</v-icon>
    </v-snackbar>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import FormExamQuestion from "@/views/FormExamQuestion";
import FormExamQuestionEdit from "@/views/FormExamQuestionEdit";
import Form from "@/views/EditForm";
export default {
  components: {
    Form,
    FormExamQuestion,
    FormExamQuestionEdit
  },
  data() {
    return {
      color: null,
      colors: ["warning"],
      top: true,
      bottom: false,
      left: false,
      right: false,
      snackbar: false,
      noticeMessage: '',
      examObj: {},
      dialogQuestion: false,
      dialogQuestionEdit: false,
      dialogExplanation: false,
      dialogEdit: false,
      questionEdit: {},
      explanationImage: '',
      
      item: {
        title: "Update quiz",
        subTitle: "Edit and update this quiz",
        width: "md6",
        submitText: "Update"
      },
      editItem: {},
      inputFields: [
        {
          label: "Quiz Name",
          type: "text",
          isEnable: true,
          name: "exam_name",
          formName: "Exam name",
          nameRules: [
            v => !!v || "Quiz name is required",
            v =>
              (v && v.length <= 150) ||
              "Quiz name must be less than 150 characters"
          ]
        },
        {
          label: "Quiz Name (Bangla)",
          type: "text",
          isEnable: true,
          name: "exam_name_bn",
          formName: "Exam name Bangla",
          nameRules: [
            v => !!v || "Quiz name (Bangla) is required",
            v =>
              (v && v.length <= 150) ||
              "Quiz name must be less than 150 characters"
          ]
        },
        {
          label: "Duration",
          type: "number",
          isEnable: true,
          name: "duration",
          formName: "duration",
          nameRules: [v => !!v || "Duration is required"]
        },
        {
          label: "Total mark",
          type: "number",
          isEnable: true,
          name: "total_mark",
          formName: "Total mark",
          nameRules: [v => !!v || "Total mark is required"]
        },
        {
          label: "Number of questions",
          type: "number",
          isEnable: true,
          name: "question_number",
          formName: "Question number",
          nameRules: [v => !!v || "Question number is required"]
        },
        {
          label: "Positive mark",
          type: "number",
          isEnable: true,
          name: "positive_mark",
          formName: "Positive mark",
          nameRules: []
        },
        {
          label: "Negative mark",
          type: "number",
          isEnable: true,
          name: "negative_mark",
          formName: "Negative mark",
          nameRules: []
        }
      ]
    }
  },
  computed: {
    ...mapState("course_subjects", ['quizDetail','quiz_title', 'questionList', 'question'])
  },
  mounted() {
  },
  created() {
    if (!this.quizDetail.id) {
      this.$router.push('/quiz')
    }
    this.getQuestions()
  },

  methods: {
    ...mapActions("course_subjects", [
      "updateExamGeneric", 'getQuestions', 'storeQuestionsMultiple', 'updateQuestions'
    ]),
    
    updateExamFields (data) {
      
      data.chapter_id = this.question.chapter_id
        ? this.question.chapter_id
        : null;
      data.course_id = this.question.course_id;
      data.subject_id = this.question.subject_id;
      data.lecture_id = this.question.lecture_id
        ? this.question.lecture_id
        : null;
      this.updateExamGeneric(data)
        .then(response => {
          if (response.status === "OK") {
            this.dialogEdit = false;
            this.color = "success";
            this.noticeMessage = "Success! " + response.messages;
            this.snack("top");
          } else {
            this.color = "warning";
            this.noticeMessage = response.messages;
            this.snack("top");
            this.dialogEdit = false;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    enabaleExamEdit (item) {
      console.log(item)
      this.dialogEdit = true
      this.editItem = item
    },
    getExamId (item) {
      this.questionEdit = {}
      this.examObj = item
      this.question.exam_id = item.id
      this.question.subject_id = item.subject_id
      this.question.lecture_id = item.lecture_id
      this.question.chapter_id = item.chapter_id
      this.question.course_id = item.course_id
      this.dialogQuestion = true
    },
    updateExam(data, status) {
      data.status = status;
      data.chapter_id = this.quizDetail.chapter_id
        ? this.quizDetail.chapter_id
        : null;
      data.course_id = this.quizDetail.course_id;
      data.subject_id = this.quizDetail.subject_id;
      data.lecture_id = this.quizDetail.lecture_id
        ? this.quizDetail.lecture_id
        : null;
      this.updateExamGeneric(data)
        .then(response => {
          if (response.status === "OK") {
            this.dialog = false;
            this.color = "success";
            this.noticeMessage = "Success! " + response.messages;
            this.snack("top");
          } else {
            this.noticeMessage = response.messages;
            this.snack("top");
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    snack(...args) {
      this.top = false;
      this.bottom = false;
      this.left = false;
      this.right = false;

      for (const loc of args) {
        this[loc] = true;
      }
      this.snackbar = true;
    },
    submitQuestion(items) {
      let data = {}
      data.chapter_id = this.question.chapter_id
        ? this.question.chapter_id
        : null;
      data.course_id = this.question.course_id
      data.subject_id = this.question.subject_id
      data.exam_id = this.question.exam_id
      data.lecture_id = this.question.lecture_id
        ? this.question.lecture_id
        : null;
      data.items = items
      // this.storeQuestions(data)
  
      this.storeQuestionsMultiple(data)
        .then(response => {
          if (response.status === 'OK') {
            this.getQuestions()
            this.dialogQuestion = false;
            if (this.examObj.questions_count) {
              this.examObj.questions_count += 1 
            } else {
              this.examObj.questions_count = 1 
            }
            this.color = "success";
            this.noticeMessage = "Success! " + response.messages;
            this.snack("top");
          } else {
            this.noticeMessage = response.messages;
            this.snack("top");
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    updateQuestion(data) {
      data.chapter_id = this.question.chapter_id
        ? this.question.chapter_id
        : null;
      data.subject_id = this.question.subject_id
      data.exam_id = this.question.exam_id
      data.lecture_id = this.question.lecture_id
        ? this.question.lecture_id
        : null;
        delete data.question_id;
      this.updateQuestions(data)
        .then(response => {
          if (response.status === 'OK') {
            this.getQuestions()
            this.dialogQuestionEdit = false;
            this.color = "success";
            this.noticeMessage = "Success! " + response.messages;
            this.snack("top");
          } else {
            this.noticeMessage = response.messages;
            this.snack("top");
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    closeQuestionEditModal() {
      this.dialogQuestionEdit = false
    },
    closeQuestionModal() {
      this.dialogQuestion = false;
    },
    editQuestion (value) {
      this.questionEdit = value
      this.dialogQuestionEdit = true
    },
    viewExplanation (imgUrl) {
      this.dialogExplanation = true
      this.explanationImage = imgUrl
    },
    closeModal() {
      this.dialog = false;
      this.dialogEdit = false;
    }
  }
};
</script>
<style scope>
.bold-font {
  font-weight: bold
}
.float-right {
  float: right;
}
</style>